import script from "./TopNavigationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavigationBar.vue?vue&type=script&setup=true&lang=js"

import "./TopNavigationBar.vue?vue&type=style&index=0&id=aa85fff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa85fff0"]])

export default __exports__